import { render, staticRenderFns } from "./AppClientEdit.vue?vue&type=template&id=a9240afa&"
import script from "./AppClientEdit.vue?vue&type=script&lang=js&"
export * from "./AppClientEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports